// useLogout.ts — logout hook that handles both MSAL and dev JWT flows.
// The MSAL path loads on demand so the library stays out of the main bundle.
import { useCallback } from 'react';
import { authEnabled } from './msalConfig';
import { clearSession } from './devAuth';
import { clearPersistedUiRole } from '@/store/store';

export function useLogout() {
  return useCallback(() => {
    // Wipe the persisted demo/QA display role so the next login can't briefly
    // render the previous account's nav before /me resolves (BUG-UI-001).
    clearPersistedUiRole();
    if (authEnabled) {
      void import('./msalRuntime').then((m) => m.msalLogout());
    } else {
      clearSession();
      window.location.href = '/login';
    }
  }, []);
}
